export default "__VITE_ASSET__DEN8VFL1__"